import "core-js/modules/es.array.push.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import Layout from '@/layouts';
import mainLayout from '@/layouts/mainLayout';

//基础路由
export const baseRoute = [{
  name: 'login',
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
}, {
  path: '/403',
  component: () => import('@/views/error/403'),
  hidden: true
}, {
  path: '/404',
  component: () => import('@/views/error/404'),
  hidden: true
}, {
  path: '/500',
  component: () => import('@/views/error/500'),
  hidden: true
}];
export const asyncRoutes = [{
  path: '/',
  component: Layout,
  redirect: '/index',
  hidden: true,
  children: [{
    name: 'index',
    path: '/index',
    component: () => import('@/views/index/menu'),
    meta: {
      title: '合作单位',
      role: 21,
      icon: 'dashboard'
    }
  },
  // {
  //   name: 'index',
  //   path: '/index',
  //   redirect: '/services/list',
  //   component: mainLayout,

  //   meta: {
  //     role: 1,
  //     title: '课程管理',
  //     icon: 'dashboard'
  //   },
  //   hiddenChildren: true,
  //   children: [
  //     {
  //       name: 'ServicesList',
  //       path: '/services/list',
  //       component: () => import('@/views/services/index'),
  //       meta: { title: '课程列表', role: 21 }
  //     },
  //     {
  //       name: 'editServices',
  //       path: '/services/edit',
  //       component: () => import('@/views/services/edit'),
  //       meta: { title: '编辑课程', role: 22 },
  //       hidden: true
  //     }

  //     // {
  //     //   name: 'bannerList',
  //     //   path: '/banner/list',
  //     //   component: () => import('@/views/index/banner'),
  //     //   meta: { title: '轮播图列表', role: 21 }
  //     // }
  //     // {
  //     //   name: 'evaluateList',
  //     //   path: '/evaluate/list',
  //     //   component: () => import('@/views/index/evaluate'),
  //     //   meta: { title: '荣誉证书', role: 21 }
  //     // }
  //   ]
  // },
  {
    name: 'notice',
    path: '/notice',
    redirect: '/notice/list',
    component: mainLayout,
    meta: {
      role: 1,
      title: '新闻中心',
      icon: 'dashboard'
    },
    hiddenChildren: true,
    children: [{
      name: 'noticeList',
      path: '/notice/list',
      component: () => import('@/views/notice/index'),
      meta: {
        title: '动态列表',
        role: 21
      }
    }, {
      name: 'editNotice',
      path: '/notice/edit',
      component: () => import('@/views/notice/edit'),
      meta: {
        title: '编辑动态',
        role: 22
      }
    }]
  },
  // {
  //   name: 'unit',
  //   path: '/unit',
  //   component: () => import('@/views/index/menu'),
  //   meta: { title: '合作单位', role: 21, icon: 'dashboard' }
  // },
  // {
  //   name: 'safetyList',
  //   path: '/safety',
  //   redirect: '/safety/list',
  //   component: mainLayout,
  //   meta: {
  //     role: 1,
  //     title: '名师列表',
  //     icon: 'dashboard'
  //   },
  //   hiddenChildren: true,
  //   children: [
  //     {
  //       name: 'safetyList',
  //       path: '/safety/list',
  //       component: () => import('@/views/index/safety'),
  //       meta: { title: '名师列表', role: 21 }
  //     },
  //     // {
  //     //   name: 'safetyDetail',
  //     //   path: '/safety/detail',
  //     //   component: () => import('@/views/index/safety-detail'),
  //     //   meta: { title: '展会详情', role: 21 },
  //     //   hidden: true
  //     // },
  //     {
  //       name: 'safetyEdit',
  //       path: '/safety/edit',
  //       component: () => import('@/views/index/safety-edit'),
  //       meta: { title: '编辑名师', role: 21 },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   name: 'goods',
  //   path: '/goods',
  //   redirect: '/goods/list',
  //   component: mainLayout,
  //   meta: {
  //     role: 1,
  //     title: '产品管理',
  //     icon: 'dashboard'
  //   },
  //   children: [
  //     {
  //       name: 'GoodsList',
  //       path: '/goods/list',
  //       component: () => import('@/views/goods/index'),
  //       meta: { title: '产品列表', role: 21 }
  //     },
  //     {
  //       name: 'GoodsCategory',
  //       path: '/goods/category',
  //       component: () => import('@/views/goods/category'),
  //       meta: { title: '产品分类', role: 21 }
  //     },
  //     {
  //       name: 'ServicesBrand',
  //       path: '/services/brand',
  //       component: () => import('@/views/services/brand'),
  //       meta: { title: '一级分类', role: 21 }
  //     },
  //     {
  //       name: 'editGoods',
  //       path: '/goods/edit',
  //       component: () => import('@/views/goods/edit'),
  //       meta: { title: '编辑产品', role: 22 },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   name: 'plan',
  //   path: '/plan',
  //   redirect: '/plan/list',
  //   component: mainLayout,
  //   meta: {
  //     role: 1,
  //     title: '电子书管理',
  //     icon: 'dashboard'
  //   },
  //   children: [
  //     {
  //       name: 'PlanList',
  //       path: '/plan/list',
  //       component: () => import('@/views/plan/index'),
  //       meta: { title: '电子书列表', role: 21 }
  //     },
  //     {
  //       name: 'PlanCategory',
  //       path: '/plan/category',
  //       component: () => import('@/views/plan/category'),
  //       meta: { title: '电子书分类', role: 21 }
  //     },
  //     {
  //       name: 'editPlan',
  //       path: '/plan/edit',
  //       component: () => import('@/views/plan/edit'),
  //       meta: { title: '编辑解决方案', role: 22 },
  //       hidden: true
  //     }
  //   ]
  // },

  //{
  //   name: 'technology',
  //   path: '/technology',
  //   redirect: '/technology/list',
  //   component: mainLayout,

  //   meta: {
  //     role: 1,
  //     title: '项目介绍',
  //     icon: 'dashboard'
  //   },
  //   hiddenChildren: true,
  //   children: [
  //     {
  //       name: 'technologyList',
  //       path: '/technology/list',
  //       component: () => import('@/views/technology/index'),
  //       meta: { title: '项目列表', role: 21 }
  //     },
  //     {
  //       name: 'editTechnology',
  //       path: '/technology/edit',
  //       component: () => import('@/views/technology/edit'),
  //       meta: { title: '编辑项目', role: 22 }
  //     }
  //   ]
  // },
  // {
  //   name: 'cooperateList',
  //   path: '/cooperate/list',
  //   component: () => import('@/views/index/cooperate'),
  //   meta: { title: '招聘职位', role: 21, icon: 'dashboard' }
  // },
  // {
  //   name: '荣誉证书',
  //   path: '/tool',
  //   component: () => import('@/views/tool/index'),
  //   meta: { title: '荣誉证书', role: 25, icon: 'bell' }
  // },
  // {
  //   name: '条款管理',
  //   path: '/solution/list',
  //   component: () => import('@/views/index/solution'),
  //   meta: { title: '条款管理', role: 21, icon: 'bell' }
  // },
  // {
  //   name: 'editSolution',
  //   path: '/solution/edit',
  //   component: () => import('@/views/index/solution-edit'),
  //   meta: { title: '编辑条款', role: 22 },
  //   hidden: true
  // },
  {
    name: 'callList',
    path: '/call/list',
    component: () => import('@/views/call/index'),
    meta: {
      title: '联系我们',
      role: 25,
      icon: 'bell'
    }
  },
  // {
  //   name: 'honorList',
  //   path: '/honor/list',
  //   component: () => import('@/views/index/honor'),
  //   meta: {
  //     title: '荣誉证书',
  //     role: 21,
  //     icon: 'dashboard'
  //   }
  // },
  // {
  //   name: 'call',
  //   path: '/call',
  //   component: () => import('@/views/call/index'),
  //   meta: {
  //     role: 1,
  //     title: '留言管理',
  //     icon: 'dashboard'
  //   }
  // },

  // {
  //   name: 'company',
  //   path: '/company',
  //   component: () => import('@/views/company/index'),
  //   meta: {
  //     role: 1,
  //     title: '公司信息',
  //     icon: 'logo'
  //   }
  // },
  // {
  //   name: 'User',
  //   path: '/user',
  //   component: () => import('@/views/user/index'),
  //   meta: {
  //     role: 6,
  //     title: '用户管理',
  //     icon: 'user'
  //   }
  // },
  {
    name: 'Account',
    path: '/account',
    component: () => import('@/views/account/index'),
    meta: {
      role: 7,
      title: '账号管理',
      icon: 'permission'
    }
  }]
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];
const createRouter = function () {
  return new VueRouter({
    routes: baseRoute.concat(asyncRoutes),
    scrollBehavior: () => ({
      y: 0
    })
  });
};
const router = createRouter();
export function resetRouter() {
  router.matcher = createRouter().matcher;
}

//重定向时报错，用这个不让他报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
export default router;